import './messenger.css';
import Topbar from '../../components/topbar/Topbar';
import Conversations from '../../components/conversations/Conversations';
import Message from '../../components/message/Message';
import SendIcon from '@material-ui/icons/Send';
import ChatOnline from '../../components/chatOnline/ChatOnline';
import { useContext, useState, useEffect, useRef } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import { io } from 'socket.io-client';

export default function Messenger() {

    const { user } = useContext(AuthContext);
    const [conversations , setConversations ] = useState([]);
    const [currentChat , setCurrentChat ] = useState(null);
    const [messages , setMessages ] = useState([]);
    const [newMessage , setNewMessage ] = useState("");
    const [arrivalMessage , setArrivalMessage ] = useState(null);
    const [onlineUsers , setOnlineUsers] = useState([]);
    const scrollRef = useRef();
    const socket = useRef();

    useEffect(() =>{

        socket.current = io("https://lets-connect-socket.herokuapp.com/");
        socket.current.on("getMessage" , data =>{
            setArrivalMessage({
                sender:data.senderId,
                text:data.text,
                createdAt : Date.now()
            });
        });

    },[]);

    useEffect(()=>{

        arrivalMessage && currentChat?.members.includes(arrivalMessage.sender) &&
        setMessages((prev) => [...prev,arrivalMessage]);

    },[arrivalMessage ,currentChat]);

    useEffect(()=>{
        socket.current.emit("addUser" , user._id);
        socket.current.on("getUsers" , (users) =>{
            setOnlineUsers(
                user.followings.filter((f) => users.some((u) => u.userId === f))
              );
        })
    },[user]);
    

    useEffect(() =>{
        
        const getConversations = async () =>{

            try{

                const res = await axios.get("https://lets-connect-app.herokuapp.com/api/conversations/" + user._id);
                setConversations(res.data);

            }catch(err){
                console.log(err);
            }
            
        };

        getConversations();

    },[user._id]);

    useEffect(() =>{

        const getMessages = async () =>{

            try{
                
                const res = await axios.get("https://lets-connect-app.herokuapp.com/api/messages/" + currentChat?._id);
                
                setMessages(res.data);

            }catch(err){
                
                console.log(err);
            }
        };

        getMessages();

    },[currentChat]);

    
    const handleSubmit = async (e) =>{

        e.preventDefault();

        const message = {
            sender : user._id,
            text : newMessage,
            conversationId: currentChat._id,
        };

        const recieverId = currentChat.members.find(member => member !== user._id);

        socket.current.emit("sendMessage",{
            senderId: user._id,
            recieverId,
            text : newMessage
        });

        try{

            const res = await axios.post("https://lets-connect-app.herokuapp.com/api/messages",message);
            setMessages([...messages , res.data]);
            setNewMessage("");

        }catch(err){
            console.log(err);
        }
    };

    useEffect(()=>{
        
        scrollRef.current?.scrollIntoView({behavior : "smooth"});

    },[messages]);



    return (
        <>
            <Topbar />
            <div className="messenger">
                <div className="chatMenu">
                    <div className="chatMenuWrapper">
                        <input placeholder = "Search for friends" className="chatMenuInput" />
                        {
                            
                            conversations.map((c) =>{
                                 return ( 
                                 <div key = { c._id } onClick={ () => setCurrentChat(c) } > 
                                    <Conversations   conversation = { c } currentUser = { user } />         
                                 </div>
                                 )
                            })
                        }
                    </div>
                </div>
                <div className="chatBox">
                    <div className="chatBoxWrapper">
                        {
                            currentChat 
                            ? (
                            <>
                                <div className="chatBoxTop">
                                    {
                                        messages.map((m) =>{
                                            return(
                                                <div key ={m._id} ref = { scrollRef }>  
                                                    <Message 
                                                         
                                                        message = { m } 
                                                        own = { m.sender === user._id }
                                                    />
                                                </div>
                                            )
                                            })
                                    }
                                    
                                    
                                </div>
                                <div className="chatBoxBottom">
                                    <textarea  
                                        className="chatMessageInput" 
                                        placeholder ="Write your message" 
                                        onChange = { (e) => setNewMessage(e.target.value) }
                                        value = { newMessage }
                                    >
                                    </textarea>
                                    <button 
                                        className="chatSubmitButton"
                                        onClick = { handleSubmit }    
                                    >
                                        Send
                                        <SendIcon />   
                                    </button>
                                </div>
                            </> )
                            : (<span className="noConversationText"> Open a conversation to start a chat.</span>)

                    }
                    </div>
                    
                </div>
                        
                <div className="chatOnline">
                    <div className="chatOnlineWrapper">
                        <div className="onlineFriendsLabel">
                            Online
                        </div>
                        <ChatOnline 
                            onlineUsers = { onlineUsers }
                            currentId = {user._id } 
                            setCurrentChat = { setCurrentChat }
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
